export const formatContactType = contactType => {
    if (!contactType) return {}

    return {
        text: contactType.description ?? undefined,
        value: contactType.uuid ?? undefined
    }
}